import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/fr';
import AddIcon from '@material-ui/icons/Add';
import {getFirstLastDateSession} from '../../helpers';
import truncateText from '../../../../app/utils/truncateText';

class CoursesListItem extends Component {
    render() {
        const {course} = this.props;

        moment.locale('fr');

        let url = '/formations/' + course.slug;

        let categoryName = '';

        if (Array.isArray(course.categories) && course.categories.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyCategories = course.categories.slice(0);
            let category = copyCategories.shift();
            categoryName = category.name;
        }

        let speakerName = '';
        let speakerJob = '';

        if (Array.isArray(course.speakers) && course.speakers.length > 0) {
            let copySpeakers = course.speakers.slice(0);
            let speaker = copySpeakers.shift();
            speakerName = speaker.full_name;
            speakerJob = speaker.job;
        }

        const dateFormat = 'D MMM YY';
        let dates = '';
        let sessions = getFirstLastDateSession(course.sessions);

        if (sessions.length === 1) {
            dates = moment(sessions[0].date, 'YYYY-MM-DD').format(dateFormat);
        } else if (sessions.length === 2) {
            if (sessions[0].date && sessions[1].date) {
                let dateTime1 = sessions[0].date;
                let dateTime2 = sessions[1].date;

                dates = moment(dateTime1, 'YYYY-MM-DD').format(dateFormat);
                dates += '<br />';
                dates += moment(dateTime2, 'YYYY-MM-DD').format(dateFormat);
            }
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={course.id}>
                <Link to={url} className="item">
                    <div className="inner">
                        <div className="top">
                            {categoryName !== '' &&
                                <div className="category">
                                    {categoryName}
                                </div>
                            }
                            <div className={classnames('dates', {
                                'multiple': (sessions.length > 1),
                            })}>
                                {ReactHtmlParser(dates)}
                            </div>
                        </div>
                        <div className="title">
                            {ReactHtmlParser(truncateText(course.title, 70))}
                        </div>
                        <div className="bottom">
                            {speakerName !== '' &&
                                <Fragment>
                                    <div className="line-1">
                                        {speakerName}
                                    </div>
                                    {speakerJob !== '' &&
                                        <div className="line-2">
                                            {speakerJob}
                                        </div>
                                    }
                                </Fragment>
                            }
                            <span className="btn-more"><AddIcon className="m-icon" /></span>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}

CoursesListItem.propTypes = {
    course: PropTypes.object.isRequired
};

export default CoursesListItem;


// WEBPACK FOOTER //
// ./src/features/Courses/components/List/CoursesListItem.js